import Controls from './_Controls'
import Delete from './Delete'

export default Controls

export {
  Delete
}
